import { FormCTA } from '@r-and-a-shared-ui/common-forms-ui';

import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';
import type { MEMBERSHIP_MODELS, SSO_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
export default {
  component: ()=>FormCTA,
  mapEntryToProps: (entry: SSO_MODELS.FormCTA & MEMBERSHIP_MODELS.FormCTA) =>
    kontentAiDataMapping.form_cta(entry),
};
